// extracted by mini-css-extract-plugin
export default {"Toast":"Toast_Toast__+IdMs","FeedbackWrap":"Toast_FeedbackWrap__TuDzc"};